import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProductCart, TProductCartPayloadRequest, TProductCartResponse, adaptProductCartFromResponse, adaptProductCartToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_PRODUCT_CART } from '../../backend-paths';


export const productCartCreateApi = createAsyncThunk(
	`POST/${BACKEND_PRODUCT_CART}`,
	(payload: TProductCartPayloadRequest, thunkApi) => {
		const dataRequest = adaptProductCartToRequest(payload);

		return HttpService.post<TProductCartResponse>(BACKEND_PRODUCT_CART, dataRequest).then(result => {
			return adaptProductCartFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProductCart> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const productCartCreateSlice = createSlice({
	name: 'productCartCreateSlice',
	initialState,
	reducers: {
		clearProductCartCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[productCartCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[productCartCreateApi.fulfilled.type]: (state, action: PayloadAction<TProductCart>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[productCartCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useProductCartCreateSelector = () => useAppSelector(state => state[productCartCreateSlice.name]);

export const { clearProductCartCreate } = productCartCreateSlice.actions;
